// Smart backend URL resolution.
// In production, the build was compiled with REACT_APP_BACKEND_URL pointing to the
// apex domain (e.g. https://nephrixapp.com) which currently has no DNS A record.
// When the user visits the site via https://www.nephrixapp.com (which works),
// we rewrite the backend URL to use the same host so API calls reach a reachable
// domain. Falls back to the env value otherwise.
const envBackendUrl = process.env.REACT_APP_BACKEND_URL || "";

export function getBackendUrl() {
  if (typeof window === "undefined") return envBackendUrl;

  try {
    const env = new URL(envBackendUrl);
    const currentHost = window.location.hostname;

    // If we're on www.<envHost> but env points to the apex (no www), use the www host.
    if (currentHost === `www.${env.hostname}`) {
      return `${window.location.protocol}//${currentHost}`;
    }

    // If we're on the same registrable domain (e.g. user navigated to apex with DNS),
    // prefer the current origin to avoid any cross-host DNS surprises.
    if (currentHost === env.hostname) {
      return window.location.origin;
    }
  } catch (_e) {
    // env URL malformed or empty — fall through to the env value.
  }

  return envBackendUrl;
}

export const BACKEND_URL = getBackendUrl();
